// React
import React from "react";

// Libraries
import PropTypes from "prop-types";

// Assets
import { Facebook, Instagram, Telegram, Twitter, Whatsapp, Personal, Whatsapp360, Email } from "@Assets";

// Styles
import styles from "./styles.module.css";

const PlatformIcon = ({ name }) => {
	const renderPlatform = () => {
		let src = null;
		const alt = String(name).toLowerCase();
		switch (name) {
			case "Facebook":
				src = Facebook;
				break;
			case "Instagram":
				src = Instagram;
				break;
			case "Telegram":
				src = Telegram;
				break;
			case "Twitter":
				src = Twitter;
				break;
			case "Whatsapp":
				src = Whatsapp;
				break;
			case "Whatsapp360":
				src = Whatsapp360;
				break;
			case "Personal":
				src = Personal;
				break;
			case "Email":
				src = Email;
				break;
			default:
				break;
		}
		return <img src={src} alt={alt} className={styles.avatarIcon} />;
	};

	return <div className={styles.avatar}>{renderPlatform(name)}</div>;
};

PlatformIcon.propTypes = {
	name: PropTypes.string.isRequired,
};

export default PlatformIcon;
